module.exports = __webpack_public_path__ + "static/media/screenshot6.c1048e08.png";